/* RRP hover-media slider: touch swipe / pointer drag.
   Follows the finger while dragging, then hands off to the slider's own
   prev/next buttons so the state in sections/main-product.liquid stays in sync. */
(function () {
  var THRESHOLD = 40;   // px of horizontal travel needed to change slide
  var DEADZONE = 6;     // px before we decide horizontal vs vertical

  function bind(slider) {
    if (slider.dataset.swipeBound === 'true') return;
    var viewport = slider.querySelector('.hover-media-slider__viewport');
    var track = slider.querySelector('[data-hover-media-track]');
    var prev = slider.querySelector('[data-hover-media-prev]');
    var next = slider.querySelector('[data-hover-media-next]');
    if (!viewport || !track || !prev || !next) return;
    slider.dataset.swipeBound = 'true';

    var dragging = false;
    var axis = null;
    var startX = 0;
    var startY = 0;
    var dx = 0;

    function index() { return parseInt(slider.getAttribute('data-current-slide') || '0', 10) || 0; }
    function total() { return parseInt(slider.getAttribute('data-total-slides') || '1', 10) || 1; }
    function basePercent() { return -index() * 100; }

    function settle() {
      track.style.transition = '';
      track.style.transform = 'translateX(' + basePercent() + '%)';
    }

    function onDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      axis = null;
      dx = 0;
      startX = e.clientX;
      startY = e.clientY;
      track.style.transition = 'none';
    }

    function onMove(e) {
      if (!dragging) return;
      var mx = e.clientX - startX;
      var my = e.clientY - startY;

      if (axis === null) {
        if (Math.abs(mx) < DEADZONE && Math.abs(my) < DEADZONE) return;
        axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (axis === 'x') {
          viewport.classList.add('is-dragging');
          try { viewport.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        }
      }
      if (axis !== 'x') return;

      dx = mx;
      var i = index();
      var t = total();
      // Rubber-band resistance when pulling past the first or last slide.
      if ((i === 0 && dx > 0) || (i === t - 1 && dx < 0)) dx = dx / 3;

      track.style.transform = 'translateX(calc(' + basePercent() + '% + ' + dx + 'px))';
      if (e.cancelable) e.preventDefault();
    }

    function onEnd(e) {
      if (!dragging) return;
      dragging = false;
      var wasHorizontal = axis === 'x';
      axis = null;
      viewport.classList.remove('is-dragging');
      try { if (e && e.pointerId != null) viewport.releasePointerCapture(e.pointerId); } catch (err) { /* ignore */ }

      var i = index();
      var t = total();
      var travel = dx;
      dx = 0;
      track.style.transition = '';

      if (wasHorizontal && travel <= -THRESHOLD && i < t - 1) { next.click(); return; }
      if (wasHorizontal && travel >= THRESHOLD && i > 0) { prev.click(); return; }
      settle();
    }

    viewport.addEventListener('pointerdown', onDown);
    viewport.addEventListener('pointermove', onMove);
    viewport.addEventListener('pointerup', onEnd);
    viewport.addEventListener('pointercancel', onEnd);
    viewport.addEventListener('pointerleave', onEnd);
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function bindAll() {
    document.querySelectorAll('[data-hover-media-slider]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  document.addEventListener('shopify:section:load', bindAll);
})();
